import _ from 'lodash';

const formatTime = time => {
  if (_.isNumber(time) && time <= 2359) {
    const timeString = time.toString();
    const hour = _.padStart(timeString.substring(0, timeString.length - 2), 2, '0');
    const minute = _.padStart(timeString.slice(-2), 2, '0');

    return `${hour}:${minute}`;
  }
};

export default formatTime;
